var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42857 0C10.798 0 11.9174 1.0705 11.9956 2.42034L12 2.57143V6.32458C12 6.72872 11.8573 7.11815 11.5998 7.42549L11.4979 7.53677L7.53677 11.4979C7.251 11.7837 6.87472 11.9581 6.47531 11.9934L6.32458 12H2.57143C1.20199 12 0.0825763 10.9295 0.0043651 9.57966L0 9.42857V2.57143C0 1.20199 1.0705 0.0825763 2.42034 0.0043651L2.57143 0H9.42857ZM9.42857 0.857143H2.57143C1.66769 0.857143 0.927287 1.55647 0.861845 2.44349L0.857143 2.57143V9.42857C0.857143 10.3323 1.55647 11.0727 2.44349 11.1382L2.57143 11.1429H6V8.57143C6 7.20199 7.0705 6.08258 8.42034 6.00436L8.57143 6H11.1429V2.57143C11.1429 1.66769 10.4435 0.927287 9.55651 0.861845L9.42857 0.857143ZM10.9564 6.85829L8.57143 6.85714C7.66769 6.85714 6.92729 7.55647 6.86185 8.44349L6.85714 8.57143V10.9551L6.93067 10.8918L10.8918 6.93067C10.9148 6.90767 10.9364 6.8835 10.9564 6.85829Z",
    fill: "#BD986A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.3bf2ce1743fa805302957aac3ffb27b5.svg";
export { ForwardRef as ReactComponent };